import {React} from 'external/react'
import {styled} from 'external/material'
import EditionSelect from './EditionSelect'
import FilterSelect from './FilterSelect'
import {resolveEdition} from '../domain/editions.cjs'

const Filters = styled('div')(({theme}) => ({
  display:'grid', gridTemplateColumns:'110px minmax(150px, 210px) 110px minmax(260px, 1fr)',
  columnGap:theme.spacing(2), rowGap:theme.spacing(2), alignItems:'start',
  padding:theme.spacing(2, 1), borderRadius:theme.shape.borderRadius,
  background:theme.palette.background.paper, border:'1px solid ' + theme.palette.divider,
  '& > div':{paddingTop:22},
  '& .MuiFormControl-root > .MuiInputBase-root':{marginTop:0},
  '& .MuiFormControl-root > label + .MuiInputBase-root':{marginTop:0},
  '& .MuiInputLabel-formControl':{top:'-22px !important', left:0, paddingLeft:0, transform:'translate(0, 0) scale(1) !important', transformOrigin:'top left', position:'absolute', fontSize:12, lineHeight:'18px'},
  '& .MuiInputLabel-shrink':{transform:'translate(0, 0) scale(1) !important'},
  '@media (max-width: 720px)':{gridTemplateColumns:'minmax(100px, 1fr) minmax(140px, 2fr)'},
  '@media (max-width: 400px)':{gridTemplateColumns:'minmax(0, 1fr)'}
}))

export default function StandardsFilters ({filters, datasets, onChange, onRetry}) {
  return <Filters>
    <EditionSelect value={resolveEdition(filters.standard_set)} onChange={value => onChange('standard_set', value)}/>
    <FilterSelect entity="subjects" field="subject" label="Materia" value={filters.subject} dataset={datasets.subjects} onChange={onChange} onRetry={onRetry}/>
    <FilterSelect entity="grades" field="grade" label="Grado" value={filters.grade} dataset={datasets.grades} onChange={onChange} onRetry={onRetry}/>
    <FilterSelect entity="standards" field="standard" label="Estándar" value={filters.standard} dataset={datasets.standards} onChange={onChange} onRetry={onRetry}/>
  </Filters>
}
